import { render, staticRenderFns } from "./promotionWithdrawalSummaryDetailExportFull.vue?vue&type=template&id=19e289b0&lang=pug"
import script from "./promotionWithdrawalSummaryDetailExportFull.vue?vue&type=script&lang=js"
export * from "./promotionWithdrawalSummaryDetailExportFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports